import { IconButton } from "@material-ui/core";
import { GetAppOutlined } from "@material-ui/icons";
import downloadIcon from "assets/img/download.svg";
import Button from "components/Button";
import { Card, CardList } from "components/Card";
import Icon from "components/Icon";
import { LightThemeTable } from "components/LightThemeTable";
import Loader from "components/Loader";
import config from "config";
import { RouteProps } from "containers/App";
import CreateBreadcrumb from "containers/CreateBreadcrumb";
import ProjectFilter, { FilterOptions } from "containers/ProjectFilter";
import Constants from "helpers/constants";
import { getItem } from "helpers/storage";
import { File } from "interfaces/file";
import { FetchAllStoresOrFilesQueryOptions } from "interfaces/filterQuery";
import moment from "moment";
import React from "react";
import Popover from "react-popover";
import { connect, ConnectedProps } from "react-redux";
import { State } from "state";
import { CHAIN_ROLE } from "state/auth";
import { deleteFileMappings, fetchAllFiles } from "state/files";
import { fetchStoresByProjectId } from "state/stores";
import { resolveStoreIdsForProject } from "utils/storeIds";
import { fetchZipForFilesDownload } from "../state/batch_download";

type ManageFilesProps = PropsFromRedux & RouteProps;

interface ManageFilesState {
  tableData: File[];
  projectId: number;
  popoverOpenId: string | number | null;
  isLoading: boolean;
  isDeleting: boolean;
  hasProjectParam: boolean;
  downloadMessage?: string;
  tableCurrentPage: number;
  tablePageSize: number;
  storeIds: string;
}

class ManageFiles extends React.Component<ManageFilesProps, ManageFilesState> {
  state = { tableData: [], projectId: 0, popoverOpenId: null, isLoading: false, isDeleting: false, hasProjectParam: false, downloadMessage: "", tableCurrentPage: 1, tablePageSize: 100, storeIds: "" };

  private resolveStoreIds = async (projectId: number) => {
    return resolveStoreIdsForProject({
      projectId,
      storeIdsInState: this.state.storeIds,
      storesInContext: this.props.stores || [],
      fetchStoresByProjectId: this.props.fetchStoresByProjectId,
    });
  };

  private loadProjectFiles = async (projectId: number) => {
    const storeIds = await this.resolveStoreIds(projectId);
    const queryOptions: FetchAllStoresOrFilesQueryOptions = {
      includeNullStore: true,
      ...(storeIds ? { storeIds } : {}),
    };

    await this.props.fetchAllFiles(projectId, queryOptions);

    this.setState({
      tableData: this.props.allMapFiles || [],
      storeIds,
      isLoading: false,
    });
  };

  public handleDelete(mappingId: string | number, maptype: "Store" | "Project") {
    const { tableCurrentPage, tablePageSize } = this.state;
    this.setState({ isDeleting: true });
    this.props.deleteFileMappings(mappingId, maptype).then(() => {
      this.loadProjectFiles(this.state.projectId).then(() => {
        const maxPage = Math.max(1, Math.ceil((this.props.allMapFiles || []).length / tablePageSize));
        this.setState({
          tableData: this.props.allMapFiles || [],
          tableCurrentPage: Math.min(tableCurrentPage, maxPage),
          isDeleting: false,
        });
      });
    });
  }

  public togglePopoverOpenId(id: string | number) {
    this.setState({ popoverOpenId: this.state.popoverOpenId ? null : id });
  }
  componentDidMount() {
    const projectIdParam = (this.props as any).match?.params?.projectId;

    if (projectIdParam) {
      const projectIdNum = parseInt(projectIdParam, 10);
      this.setState({ projectId: projectIdNum, isLoading: true, hasProjectParam: true });
    }
  }

  componentDidUpdate(prevProps: ManageFilesProps, prevState: ManageFilesState) {
  if (prevState.projectId !== this.state.projectId && this.state.projectId > 0) {
    this.setState({ isLoading: true, tableCurrentPage: 1 });

    this.loadProjectFiles(this.state.projectId);
  }
}
  downloadFile = (id: string) => {
      // if (!url) return;
      // const encodedUrl = encodeURI(url);
      // window.open(encodedUrl, "_blank");
      if(!id) return;
      window.open(`${config.API_SERVICE_URL}/api/file/${id}`);
  };

  downloadFiles = (files: File[]) => {
    if (!files || files.length === 0) {
      return;
    }

    files.forEach((file: File) => {
        if (file.id) {
          window.open(`${config.API_SERVICE_URL}/api/file/${file.id}`);
        }
      });
    };
  handleZipDownload = () => {
    const chainPermissionString = getItem(CHAIN_ROLE);
    const chainPermission = JSON.parse(chainPermissionString || "[]");

    const RestrictedRole = [
      Constants.VIEWER_NO_PSA_ACCESS,
      Constants.CONTRIBUTER_NO_PSA_ACCESS
    ];

    const restrictedUser = RestrictedRole.includes(chainPermission.role);

    const filesToDownload = restrictedUser
      ? this.state.tableData.filter(
          (file: File) => !file?.name.toLowerCase().endsWith(".psa")
        )
      : this.state.tableData;

    if (!filesToDownload || filesToDownload.length === 0) {
      return;
    }

    const fileList = filesToDownload.map((file: File) => ({
      status: file.status,
      blob_url: file.blob_url,
      filename: file.name,
    }));

    const project = String(this.state.projectId);
    const chain = "";

    // clear old message first
    this.setState({ downloadMessage: "" });

    // this.props.fetchZipForFilesDownload(project, chain, fileList)
    //   .then(() => {
    //     const blob = this.props.batch_download;

    //     if (blob) {
    //       const url = window.URL.createObjectURL(
    //         new Blob([blob], { type: "application/zip" })
    //       );
    //       const link = document.createElement("a");
    //       link.href = url;
    //       link.setAttribute("download", `${project}.zip`);
    //       document.body.appendChild(link);
    //       link.click();
    //       link.remove();
    //       window.URL.revokeObjectURL(url);
    //     }

    //     this.setState({
    //       downloadMessage: "File(s) will be shared via email."
    //     });
    //   });
    // CALL API (no .then dependency)
    this.props.fetchZipForFilesDownload(project, chain, fileList);

    // SHOW MESSAGE IMMEDIATELY
    this.setState(
        { downloadMessage: "Your files will be emailed soon." },
        () => {
          // hide after 5 seconds
          setTimeout(() => {
            this.setState({ downloadMessage: "" });
          }, 5000);
        }
      );

  };
  public render() {
      const chainPermissionString = getItem(CHAIN_ROLE);
      const chainPermission = JSON.parse(chainPermissionString || "[]");
      let Files: File[] = [];
      const permission = chainPermission; 
      const AllowedRole = [
        Constants.INTERNAL_PROJECT_ADMIN,
        Constants.EXTERNAL_PROJECT_ADMIN
      ];
      const projectAdmins = AllowedRole.includes(permission.role_name ? permission.role_name : permission.role)

      const RestrictedRole = [
        Constants.VIEWER_NO_PSA_ACCESS,
        Constants.CONTRIBUTER_NO_PSA_ACCESS
      ];
    const restrcitedUser = RestrictedRole.includes(permission.role)

    if(restrcitedUser){
      // Remove .psa files from files array
      const filteredFiles = this.state.tableData.filter(
        (file : any) => !file?.name.toLowerCase().endsWith(".psa")
      );
      Files = filteredFiles;
    }else{
      Files = this.state.tableData
    }
    return (
      <section className="manage-data-container">
        <CreateBreadcrumb
          crumbs={{
            crumbs: [
              {
                to: "/manage-all-data",
                crumb: "VIEW ALL DATA",
                dataQa: "view-all-data-link",
              },
            ],
          }}
        />
        <div className="manage-data-body">
          <div style={{ paddingLeft: "16px", paddingRight: "16px" }}>

            <h2 className="header" style={{  marginTop: "16px", marginBottom: "0px" }}>Manage Files</h2>

            <div style={{ 
              display: "flex", 
              justifyContent: "space-between", 
              alignItems: "center",
              marginBottom: "0px",
              marginTop: "0px",
              marginLeft:"0px",
              padding: "16px 0",
              flexWrap: "wrap", 
              gap: "16px"
            }}>

              <div data-qa="project-dropdown" style={{ marginLeft: "0px", marginBottom: "0px" }}>
                <ProjectFilter
                  onChange={({ id }: FilterOptions) => {
                    if (!this.state.hasProjectParam) {
                      this.setState({
                        isLoading: true,
                        storeIds: "",
                        tableCurrentPage: 1,
                        projectId: id,
                      });
                    }
                  }}
                  isSearchable={!this.state.hasProjectParam}
                  isDisabled={this.state.hasProjectParam}
                  value={this.state.projectId || undefined} 
                />
              </div>

              <button
                onClick={() =>
                  Files.length > 2
                    ? this.handleZipDownload()
                    : this.downloadFiles(Files)
                }
                disabled={!Files || Files.length === 0}
                data-qa="download-all-files-button"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  padding: "8px 16px",
                  backgroundColor: Files && Files.length > 0 ? "#E5B42F" : "#cccccc",
                  color: "#ffffff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: Files && Files.length > 0 ? "pointer" : "not-allowed",
                  transition: "all 0.2s ease",
                  fontSize: "14px",
                  marginBottom: "0px"
                }}
                title={
                  Files && Files.length > 0
                    ? Files.length > 2
                      ? "Download files as ZIP"
                      : "Download files"
                    : "No files to download"
                }
              >
                <img
                  src={downloadIcon}
                  alt="Download"
                  style={{
                    width: 22,
                    height: 22,
                    pointerEvents: "none",
                    filter: "brightness(0) invert(1)"
                  }}
                />
                Download Files
              </button>
            </div>
            {this.state.downloadMessage && (
              <div
                style={{
                  marginTop: "8px",
                  fontSize: "12px",
                  color: "#2e7d32",
                  fontWeight: 500,
                }}
                data-qa="zip-download-message"
              >
                {this.state.downloadMessage}
              </div>
            )}

            {this.state.isLoading ? (
              <Loader />          
            ) : (
            <div style={{ marginBottom: "10px" }}>
            <CardList>
              <Card>
                <LightThemeTable
                  data={Files || []}
                  currentPage={this.state.tableCurrentPage}
                  defaultPageSize={this.state.tablePageSize}
                  onPageChange={(page: number, size: number) => this.setState({ tableCurrentPage: page, tablePageSize: size }) }
                  columns={[
                    {
                      field: "maptype",
                      header: "File Type",
                      dataQa: "file-type",
                    },
                    {
                      field: "name",
                      header: "File Name",
                      dataQa: "file-name",
                    },
                    {
                      field: "storeno",
                      header: "Store No.",
                      dataQa: "store-number",
                    },
                    {
                      field: "user_name",
                      header: "Uploaded By",
                      dataQa: "uploaded-by",
                    },
                    {
                      field: "updated_at",
                      header: "Upload Date",
                      dataQa: "upload-date",
                      formatter: (value) => {
                        const date = moment(value);

                        if (!date.isValid()) {
                          return "--";
                        }

                        return date.format("M/D/YYYY h:mm A");
                      },
                    },
                    {
                      field: "",
                      header: "",
                      sortable: false,
                      dataQa: "delete-filemap",
                      formatter: (value: any, row: any, index: any) => {
                        return (
                          <Popover
                            body={
                              <div
                                style={{
                                  display: "flex-inline",
                                }}
                              >
                                <p>Delete mapping for this file?</p>
                                <Button
                                  data-qa="confirm-delete-button"
                                  warning={true}
                                  style={{
                                    padding: "6px 12px",
                                    borderRadius: 4,
                                    background:  "#E5B42F",
                                    color: "#0F0F0F",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => this.handleDelete(row.mapid, row.maptype)}
                                >
                                  DELETE
                                </Button>
                                <Button
                                  data-qa="cancel-delete-button"
                                  secondary={true}
                                  style={{
                                    padding: "6px 12px",
                                    borderRadius: 4,
                                    color: "#0F0F0F",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => this.togglePopoverOpenId(row.mapid)}
                                >
                                  CANCEL
                                </Button>
                              </div>
                            }
                            isOpen={this.state.popoverOpenId === row.mapid}
                            preferPlace="left"
                          >
                          <div style={{ display: "flex", alignItems: "center" }}>
                            {(this.props.user?.role === Constants.AB_SYSTEM_ADMIN|| projectAdmins) && (
                              <button
                                style={{ outline: "none" }}
                                className="delete-comment-button"
                                data-qa="delete-button"
                                onClick={(e) => this.togglePopoverOpenId(row.mapid)}
                              >
                                <Icon medium={true} src={require("../assets/img/Delete.png")} style={{width:22}}/>
                              </button>
                            )}

                            <IconButton
                              size="small"
                              style={{ padding: 0, marginLeft: 8 }}
                              onClick={() => this.downloadFile(row.id)}
                            >
                              <GetAppOutlined style={{ color: "#E5B611" }} />
                            </IconButton>
                          </div>
                          </Popover>
                        );
                      },
                    },
                  ]}
                />
              </Card>
            </CardList>
            </div>
          )}
          </div>
        </div>
      </section>
    );
  }
}

const connecter = connect(
  (state: State) => ({
    projects: state.my_projects.content,
    allMapFiles: state.files.content?.data,
    stores: state.stores.content?.data,
    user: state.auth_user.content,
    batch_download: state.batch_download.content,
  }),
  { fetchAllFiles, fetchStoresByProjectId, deleteFileMappings, fetchZipForFilesDownload  }
);

type PropsFromRedux = ConnectedProps<typeof connecter>;

export default connecter(ManageFiles);
 